import { Button, Props as ButtonProps } from '../Button';

import styles from './index.module.css';

interface Props extends React.PropsWithChildren<ButtonProps> {
  showSpinner: boolean;
}

const SpinnerButton: React.FC<Props> = ({
  showSpinner,
  children,
  ...buttonProps
}) => {
  return (
    <Button {...buttonProps}>
      {showSpinner ? <div className={styles.Spinner} /> : children}
    </Button>
  );
};

export default SpinnerButton;
